import { render, staticRenderFns } from "./survey-thank-you.vue?vue&type=template&id=3c393856&"
import script from "./survey-thank-you.vue?vue&type=script&lang=js&"
export * from "./survey-thank-you.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c393856')) {
      api.createRecord('3c393856', component.options)
    } else {
      api.reload('3c393856', component.options)
    }
    module.hot.accept("./survey-thank-you.vue?vue&type=template&id=3c393856&", function () {
      api.rerender('3c393856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey-thank-you.vue"
export default component.exports